<template>
  <bk-bets-list :data-func="getBets" :show-user="true" />
</template>
<script>
  import bkService from '../../../../services/bk.service'

  import bkBetsList from '../../../common/bk-bets-list.vue'

  export default {
    name: 'player-bk-bets',
    components: { bkBetsList },
    computed: {
      playerId() {
        return this.$route.params.playerId;
      }
    },
    methods: {
      async getBets(filter) {
        filter.userId = this.playerId;
        return await bkService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/players/player/bk-bets.vue